module.exports = __webpack_public_path__ + "img/ic_services_disability.f559b175.svg";